import React, { Component } from 'react';

class ImageModal extends Component {

  constructor(props) {
    super(props);
    this.onBackdropClick = this.onBackdropClick.bind(this);
  }

  onBackdropClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.dispatchCloseModal();
  }

  render() {
    return (
      <div>      
        <div className="modal-header">
          <button onClick={this.onBackdropClick} type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 className="modal-title">{this.props.modalComponentProps.modalPhotoTitle}</h4>
        </div>
        <div className="modal-body center-text">
          <img className="photo" src={this.props.modalComponentProps.modalPhotoUrl} role="presentation" />
        </div>
        <div className="modal-footer">
          <button onClick={this.onBackdropClick} type="button" className="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>
    );
  }
}

export default ImageModal;



/** WEBPACK FOOTER **
 ** ./src/image-display/ImageModal.js
 **/